import { put } from 'redux-saga/effects'

export function* setCalendarSaga(action) {
  yield put({
    type: 'SET_CALENDAR',
    payload: {
      clientId: action.payload.customerId,
      startDate: action.payload.startDate,
      endDate: action.payload.endDate,
    }
  })
}
